(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-popup"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var STORAGE_KEY = 'nvl_welcome_popup_seen';

    var popup = document.getElementById('nvl-welcome-popup');
    if (!popup) return;

    // An document.body hängen, damit position:fixed nicht von Theme-Containern
    // mit transform/overflow ausgehebelt wird.
    document.body.appendChild(popup);

    if (localStorage.getItem(STORAGE_KEY)) {
      return;
    }

    var timerId = null;

    function showPopup() {
      // Flag SOFORT setzen, nicht erst beim Schließen/Absenden,
      // sonst erscheint das Popup bei jedem Seitenwechsel erneut.
      localStorage.setItem(STORAGE_KEY, '1');

      popup.classList.add('nvl-show');
      popup.setAttribute('aria-hidden', 'false');

      if (timerId) {
        clearTimeout(timerId);
        timerId = null;
      }
      document.removeEventListener('mouseout', handleExitIntent);
    }

    function closePopup() {
      popup.classList.remove('nvl-show');
      popup.setAttribute('aria-hidden', 'true');
    }

    function handleExitIntent(e) {
      if (!e.relatedTarget && !e.toElement && e.clientY <= 0) {
        showPopup();
      }
    }

    // Trigger 1: 10 Sekunden
    timerId = setTimeout(showPopup, 10000);

    // Trigger 2: Exit-Intent (Maus Richtung oberer Bildschirmrand)
    document.addEventListener('mouseout', handleExitIntent);

    // Schließen
    popup.querySelectorAll('[data-nvl-close]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });

    // E-Mail Formular -> /contact (Shopify Newsletter-Endpoint), ohne Reload
    var form = document.getElementById('nvl-popup-form');
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var emailInput = form.querySelector('input[name="email"]');
      var email = (emailInput.value || '').trim();
      if (!email) return;

      var submitBtn = form.querySelector('button[type="submit"]');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Einen Moment...';

      var body = new URLSearchParams();
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      body.append('contact[email]', email);
      body.append('contact[tags]', 'newsletter,popup-willkommen10');

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      })
        .catch(function () {
          // Auch bei Netzwerkfehler den Code zeigen, damit der Kunde nicht blockiert wird
        })
        .finally(function () {
          document.getElementById('nvl-popup-step-email').style.display = 'none';
          var codeStep = document.getElementById('nvl-popup-step-code');
          codeStep.style.display = 'block';
        });
    });

    // Code kopieren
    var copyBtn = popup.querySelector('[data-nvl-copy]');
    copyBtn.addEventListener('click', function () {
      navigator.clipboard.writeText('WILLKOMMEN10').then(function () {
        var original = copyBtn.textContent;
        copyBtn.textContent = 'Kopiert ✓';
        setTimeout(function () {
          copyBtn.textContent = original;
        }, 2000);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
